(() => {
  const selector = '.product-media';

  function applyZoom(event) {
    if (event.pointerType !== 'mouse') return;

    const media = event.target.closest(selector);
    if (!media) return;

    const image = media.querySelector('img.product-media__image');
    if (!image) return;

    const rect = media.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    const x = Math.max(0, Math.min(100,
      ((event.clientX - rect.left) / rect.width) * 100
    ));
    const y = Math.max(0, Math.min(100,
      ((event.clientY - rect.top) / rect.height) * 100
    ));

    const container =
      media.closest('.product-media-container--force-aspect') || media;

    container.style.setProperty('overflow', 'hidden', 'important');
    media.style.setProperty('overflow', 'hidden', 'important');

    image.style.setProperty('transform-origin', `${x}% ${y}%`, 'important');
    image.style.setProperty('transform', 'scale(2)', 'important');
    image.style.setProperty('transition', 'transform 0.08s linear', 'important');
  }

  function removeZoom(event) {
    const media = event.target.closest(selector);
    if (!media || media.contains(event.relatedTarget)) return;

    const image = media.querySelector('img.product-media__image');
    const container =
      media.closest('.product-media-container--force-aspect') || media;

    if (image) {
      image.style.removeProperty('transform');
      image.style.removeProperty('transform-origin');
      image.style.removeProperty('transition');
    }

    media.style.removeProperty('overflow');
    container.style.removeProperty('overflow');
  }

  document.addEventListener('pointerover', applyZoom);
  document.addEventListener('pointermove', applyZoom);
  document.addEventListener('pointerout', removeZoom);
})();